import { useEffect, useRef, useState, ReactNode } from 'react'
import { H1 } from './Typography'
import LogoMark from './Logo'

interface InstructorRevealProps {
  src: string
  name: string
  role: string
  children: ReactNode
}

// قاب پرتره — اگر عکس لود نشود یا موجود نباشد، قاب برندشده نمایش داده می‌شود
// موبایل: تمام‌عرض مثل کاور مجله؛ دسکتاپ: قاب بزرگ ۴۱۶px با نسبت ۴:۵ (مطابق خروجی اصلی عکس)
const Portrait = ({ src, alt }: { src: string; alt: string }) => {
  const [loaded, setLoaded] = useState(false)

  return (
    <div className="relative w-full md:w-[26rem] aspect-[4/5] rounded-[1.75rem] md:rounded-[2rem] overflow-hidden shadow-2xl ring-1 ring-black/10 bg-gradient-to-br from-secondary-100 to-primary-100 dark:from-secondary-900/40 dark:to-primary-900/40">
      {!loaded && (
        <div className="absolute inset-0 flex flex-col items-center justify-center gap-4 text-secondary-500 dark:text-secondary-300">
          <LogoMark className="h-10 w-10" />
          <span className="text-xs tracking-[0.3em] opacity-70">{alt}</span>
        </div>
      )}
      <img
        src={src}
        srcSet="/images/instructor-thumb.jpg 600w, /images/instructor.jpg 2000w"
        sizes="(max-width: 768px) 92vw, 416px"
        alt={alt}
        onLoad={() => setLoaded(true)}
        onError={() => setLoaded(false)}
        className={`h-full w-full object-cover transition-opacity duration-700 ${
          loaded ? 'opacity-100' : 'opacity-0'
        }`}
      />
      {/* هالهٔ ماه پشت قاب */}
      <div className="absolute -inset-6 -z-10 rounded-[2.5rem] bg-secondary-300/25 blur-2xl dark:bg-secondary-500/10" />
    </div>
  )
}

/**
 * لحظهٔ امضای صفحه — پرترهٔ مدرس در دسکتاپ هنگام اسکرول از گوشهٔ پایین
 * به جای طبیعی خودش سُر می‌خورد و بزرگ می‌شود؛ در موبایل بالای متن قرار می‌گیرد.
 * عکس: public/images/instructor.jpg (کافی است فایل را جایگزین کنید)
 */
const InstructorReveal = ({ src, name, role, children }: InstructorRevealProps) => {
  const ref = useRef<HTMLDivElement>(null)
  const [t, setT] = useState(0)
  const [isDesktop, setIsDesktop] = useState(false)

  useEffect(() => {
    const mq = window.matchMedia('(min-width: 768px)')
    setIsDesktop(mq.matches)
    const onMq = () => setIsDesktop(mq.matches)
    mq.addEventListener('change', onMq)
    return () => mq.removeEventListener('change', onMq)
  }, [])

  useEffect(() => {
    let raf = 0
    const update = () => {
      const node = ref.current
      if (node) {
        const rect = node.getBoundingClientRect()
        const vh = window.innerHeight
        const raw = (vh * 0.9 - rect.top) / (vh * 0.6)
        setT(Math.max(0, Math.min(1, raw)))
      }
      raf = 0
    }
    const onScroll = () => {
      if (!raf) raf = requestAnimationFrame(update)
    }
    update()
    window.addEventListener('scroll', onScroll, { passive: true })
    window.addEventListener('resize', onScroll)
    return () => {
      window.removeEventListener('scroll', onScroll)
      window.removeEventListener('resize', onScroll)
      cancelAnimationFrame(raf)
    }
  }, [])

  return (
    <section
      id="about"
      ref={ref}
      className="relative md:min-h-[115vh] flex items-center overflow-hidden py-24 md:py-0"
    >
      <div className="container-custom w-full">
        <div className="md:grid md:grid-cols-2 md:items-center md:gap-10">
          {/* متن — ستون راست؛ در موبایل با اسکرول نرم ظاهر می‌شود */}
          <div
            className="max-w-xl text-center md:text-right order-2 md:order-1 mt-12 md:mt-0"
            style={
              !isDesktop
                ? {
                    opacity: 0.45 + t * 0.55,
                    transform: `translateY(${(1 - t) * 24}px)`,
                  }
                : undefined
            }
          >
            <p className="mb-4 text-xs tracking-[0.3em] uppercase text-secondary-600 dark:text-secondary-300">
              {role}
            </p>
            <H1 className="!text-4xl md:!text-6xl !leading-snug text-balance mb-8">{name}</H1>
            {children}
          </div>

          {/* پرتره — دسکتاپ: سُر خوردن از گوشه؛ موبایل: ورود نرم با اسکرول + فاصله از چیپ‌ها */}
          <div
            className="order-1 md:order-2 mt-12 md:mt-0 flex justify-center md:justify-start will-change-transform"
            style={
              isDesktop
                ? {
                    transform: `translate(${(t - 1) * 16}vw, ${(1 - t) * 32}vh) scale(${0.6 + t * 0.4})`,
                    opacity: Math.min(1, 0.45 + t * 1.1),
                  }
                : {
                    transform: `translateY(${(1 - t) * 48}px) scale(${0.97 + t * 0.03})`,
                    opacity: Math.min(1, 0.4 + t * 1.2),
                  }
            }
          >
            <Portrait src={src} alt="الهام ابویی" />
          </div>
        </div>
      </div>
    </section>
  )
}

export default InstructorReveal
